import { Column, FlexBox } from '@dixa/lib-shared-habla';
import { PropsWithChildren } from 'lib-shared-types-utils';

import { ContactsSidebarTop } from './components/top/contactsSidebarTop';

export function ContactsSidebar({ children }: PropsWithChildren): JSX.Element {
  return (
    <FlexBox flexDirection="column" height="100%">
      <ContactsSidebarTop />

      <Column.Row scrollable size={1} noHorizontalPadding noVerticalPadding>
        {children}
      </Column.Row>
    </FlexBox>
  );
}
